import { TreeView, TreeViewItem, TreeViewItemContent } from '@adobe/react-spectrum';
import { FPAItem } from '../../../../infra/protected/FPA/FPAItem';
import { Key, Selection, Text } from '@adobe/react-spectrum';
import { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export interface IFinderContextTreeProps {
    items: FPAItem[];
    onSelection?: (key: string) => void;
    expandedKeys?: Set<Key>;
    setExpandedKeys?: (keys: Set<Key>) => void;
    selectedKeys?: Selection;
    setSelectedKeys?: (keys: Selection) => void;
    /** When set (including `0`), scrolls the selected tree row into view after layout updates. */
    scrollIntoViewKey?: string | number | null;
}

const TreeItem = (
    item: FPAItem,
    translateLabel: (label?: string) => string,
) => (
    <TreeViewItem id={item.id} key={item.id} textValue={translateLabel(item.title)} hasChildItems={item.childItems?.length > 0}>
        <TreeViewItemContent>
            <Text>{translateLabel(item.title)}</Text>
        </TreeViewItemContent>
        {item.childItems?.map(child => TreeItem(child, translateLabel))}
    </TreeViewItem>
);

export function FinderContextTree ({ 
    items, 
    onSelection,
    expandedKeys = new Set<Key>(),
    setExpandedKeys,
    selectedKeys = new Set<Key>(),
    setSelectedKeys,
    scrollIntoViewKey,
}: IFinderContextTreeProps) {
    const { t } = useTranslation();
    const translateLabel = (label?: string) =>
        t(label || "", { ns: "common", defaultValue: label || "" });

    const handleSelectionChange = (key: any) => { 
        if (setSelectedKeys) setSelectedKeys(key);
        if (onSelection) onSelection(key.currentKey);
    };

    const handleExpandedChange = (keys: Set<Key>) => {
        if (setExpandedKeys) setExpandedKeys(keys);
    };

    return (
        <TreeView
            aria-label={t('choose_context', { ns: 'finder', defaultValue: 'Choose context' })}
            items={items}
            selectionMode="single"
            onSelectionChange={handleSelectionChange}
            onExpandedChange={handleExpandedChange}
            height={'size-6000'}
            selectionStyle='highlight'
            expandedKeys={expandedKeys}
            selectedKeys={selectedKeys}
        >
            {(item: FPAItem) => TreeItem(item, translateLabel)}
        </TreeView>
    );
}
